import React from 'react';

const Stats = () => {
  return (
    <section className="py-20 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
          <div>
            <div className="text-4xl md:text-5xl font-bold mb-2">500+</div>
            <h5 className="text-xl font-semibold mb-4">Beauty Transformations</h5>
            <p className="text-gray-300">
              Successful skincare consultations and makeup applications that have 
              enhanced our clients' natural beauty and boosted their confidence.
            </p>
          </div>

          <div>
            <div className="text-4xl md:text-5xl font-bold mb-2">200+</div>
            <h5 className="text-xl font-semibold mb-4">Happy Clients</h5>
            <p className="text-gray-300">
              Satisfied clients who trust KADIBIA BEAUTY for their skincare needs, 
              makeup services, and beauty education requirements.
            </p>
          </div>

          <div>
            <div className="text-4xl md:text-5xl font-bold mb-2">50+</div>
            <h5 className="text-xl font-semibold mb-4">Premium Products</h5>
            <p className="text-gray-300">
              Carefully curated foreign skincare and makeup products from 
              trusted international brands for all skin types and tones.
            </p>
          </div>

          <div>
            <div className="text-4xl md:text-5xl font-bold mb-2">98%</div>
            <h5 className="text-xl font-semibold mb-4">Client Satisfaction</h5>
            <p className="text-gray-300">
              Outstanding client satisfaction rate reflecting our commitment 
              to excellence in beauty services and personalized care.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Stats;